import React, { useEffect, useState } from "react";
import { Form, Input, Button, Upload, Select, Row, Col, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";

const { Option } = Select;

const DriversForm = ({ formData, setFormData, closeModal, refetchData }) => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [imageFileList, setImageFileList] = useState([]);
  const [licenceFileList, setLicenceFileList] = useState([]);

  useEffect(() => {
    form.setFieldsValue(formData);
  }, [formData, form]);

  const handleFileChange = ({ fileList }) => setFileList(fileList);
  const handleImageFileChange = ({ fileList }) => setImageFileList(fileList);
  const handleLicenceFileChange = ({ fileList }) => setLicenceFileList(fileList);

  const onFinish = async (values) => {
    const formData = new FormData();
    Object.keys(values).forEach((key) => {
      formData.append(key, values[key]);
    });

    fileList.forEach(({ originFileObj }) => {
      formData.append("documents", originFileObj);
    });

    imageFileList.forEach(({ originFileObj }) => {
      formData.append("driverImage", originFileObj);
    });

    licenceFileList.forEach(({ originFileObj }) => {
      formData.append("driverLicence", originFileObj);
    });

    try {
      if (formData.id) {
        await axios.put(`http://93.127.203.113:5005/drivers/${formData.id}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        message.success("Driver updated successfully");
      } else {
        await axios.post("http://93.127.203.113:5005/drivers", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        message.success("Driver added successfully");
      }

      setFormData({});
      closeModal();
      refetchData();
    } catch (error) {
      console.error(error);
      message.error("Failed to save driver");
    }
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
      style={{
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        border: "1px solid #0c8c49",
        background: "#fff",
      }}
    >
      <Row gutter={[24, 24]}>
        <Col span={12}>
          <Form.Item
            label="First Name"
            name="firstName"
            rules={[{ required: true, message: "Please enter a first name" }]}
          >
            <Input placeholder="Enter first name" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Last Name"
            name="lastName"
            rules={[{ required: true, message: "Please enter a last name" }]}
          >
            <Input placeholder="Enter last name" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[24, 24]}>
        <Col span={12}>
          <Form.Item
            label="Phone Number"
            name="phoneNumber"
            rules={[{ required: true, message: "Please enter a phone number" }]}
          >
            <Input placeholder="Enter phone number" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Status"
            name="status"
            rules={[{ required: true, message: "Please select a status" }]}
          >
            <Select placeholder="Select status">
              <Option value="Pending">Pending</Option>
              <Option value="Active">Active</Option>
              <Option value="Inactive">Inactive</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[24, 24]}>
        <Col span={12}>
          <Form.Item label="Driver Image">
            <Upload
              fileList={imageFileList}
              onChange={handleImageFileChange}
              beforeUpload={() => false}
            >
              <Button icon={<UploadOutlined />}>Upload Image</Button>
            </Upload>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Driver Licence">
            <Upload
              fileList={licenceFileList}
              onChange={handleLicenceFileChange}
              beforeUpload={() => false}
            >
              <Button icon={<UploadOutlined />}>Upload Licence</Button>
            </Upload>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[24, 24]}>
        <Col span={12}>
          <Form.Item label="Documents">
            <Upload
              fileList={fileList}
              onChange={handleFileChange}
              beforeUpload={() => false}
            >
              <Button icon={<UploadOutlined />}>Upload Documents</Button>
            </Upload>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24} style={{ textAlign: "right" }}>
          <Button type="primary" htmlType="submit" style={{ marginRight: 10 }}>
            Save
          </Button>
          <Button htmlType="button" onClick={() => form.resetFields()}>
            Reset
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default DriversForm;
